// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3797b6ec","389":"01b40482","732":"01c6a0d0"}[chunkId] + ".chunk.js";
};